import React from 'react'
import { SherpaLogo } from './SherpaLogo'

const OracleVoiceModeGlowIcon: React.FC = () => {
  return (
    <div className="loading-ai-icon">
      {/* Glowing background circle */}
      <div className="glow-background" />

      {/* Sherpa Logo with listening animation */}
      <div className="listening-indicator">
        <SherpaLogo width="100%" height="100%" className="ai-icon-svg" />
      </div>
    </div>
  )
}

export default OracleVoiceModeGlowIcon
